export default __webpack_public_path__ + "static/media/IMG_9959.f70492ff.jpg";